import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  AllocationViewSupportSMSInitialState,
  AllocationViewSupportSMSCountryCodesLoad,
  AllocationViewSupportedSMSSet,
} from './allocation-view-support-sms.actions';
import { AllocationViewSupportSMSState } from './allocation-view-support-sms.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewSupportSMSFacade implements LoadDataFacade, SetInitialStateFacade {
  countryCodes$: Observable<string[]> = this.store.select(AllocationViewSupportSMSState.getSupportedCoutries);
  isSupportedSMS$: Observable<boolean> = this.store.select(AllocationViewSupportSMSState.isSupportedSMS);
  loaded$: Observable<boolean> = this.store.select(AllocationViewSupportSMSState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new AllocationViewSupportSMSCountryCodesLoad());
  }

  setSupportSMS(value: boolean): void {
    this.store.dispatch(new AllocationViewSupportedSMSSet(value));
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewSupportSMSInitialState());
  }
}
